<template>
<div>
  <div>
<!--    <el-button size="mini" type="primary" icon="el-icon-upload" round @click="add">上传</el-button>-->
    <el-link type="primary" class="el-link-common" @click="add">上传文件</el-link>
    <span style="margin-right: 10px;"></span>
    <slot></slot>
  </div>
  <el-table :data="list" border max-height="400" size="mini" empty-text="请上传文件">
    <el-table-column
      prop="FitmentID"
      label="文件名称"
      width="200">
      <template slot-scope="scope">
        <el-link type="primary" @click="showDow(scope.row,1)">
          <span class="link-span" :title="scope.row.file_name">{{scope.row.file_name}}</span>
        </el-link>
      </template>
    </el-table-column>
    <el-table-column
      label="上传人/时间"
      width="180">
      <template slot-scope="scope">
        {{scope.row.user_name}} / {{scope.row.create_time}}
      </template>
    </el-table-column>
    <el-table-column
      label="	操作"
      width="100">
        <template slot-scope="scope">
          <el-link @click="showDow(scope.row,0)" type="primary" size="mini">下载</el-link>
          <el-link @click="del(scope.row)" type="danger" size="mini">移除</el-link>
        </template>
    </el-table-column>
    <el-table-column label="备注">
        <template slot-scope="scope">
          <el-input v-model="scope.row.remarks" style="width: 200px;"></el-input>
          <el-link @click="changeRemark(scope.row.id,scope.row.remarks)" type="primary" size="mini">保存备注</el-link>
        </template>
    </el-table-column>
  </el-table>

  <ViewFile ref="ViewFile" />
</div>
</template>

<script>
import Http from "../../../common/Http";
import ViewFile from "../../../../../Common/ViewFile";

export default {
  name: "FitmentFileSubgroup",
  components: {ViewFile},
  props:['fitment_id','mode_type'],
  data(){
    return{
      list:[]
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    getList(){
      const that=this;
      ERP.postRequest({
        url:"admin/HouseFitmentFile/getList",
        data:{
          fitment_id:that.fitment_id,
          mode_type:that.mode_type,
          page: 1,
          page_size: 50
        },
      },ret=>{
        if(ret.code){
          that.list=ret.data.list;
        }
      })
    },
    showDow(item,type=1){
      const that=this;
      let file_path=encodeURIComponent(item.file_path);
      let file_url=`http://oss.gdzawy.com:9000/oss/index/download?bucket=gdza&path=${file_path}`;
      if(type===1){
        ERP.getRequest({
          url:`http://oss.gdzawy.com:9000/oss/index/downloadObj?bucket=gdza&path=${file_path}`,
          data:{},
        },ret=>{
          if(ret.code){
            that.$refs.ViewFile.show({
              width: '90vw',
              height:'80vh',
              title:item.file_name,
              src:ret.data,
              download(){
                window.open(file_url)
              }
            })
          }else {
            that.$message.error('预览异常')
          }
        })

      }else {
        window.open(file_url)
      }
    },
    del(item){
      const that=this;
      ERP.postRequest({
        url:"admin/HouseFitmentFile/delete",
        data:{
          id:item.id,
        },
      },ret=>{
        if(ret.code){
          that.$message.success('操作成功')
          that.getList()
        }else {
          that.$message.error(ret.msg||'操作失败')
        }
      })
    },
    add(){
      const that=this;
      Http.uploadFile(flie_item=>{
        ERP.postRequest({
          url:"admin/HouseFitmentFile/save",
          data:{
            fitment_id:that.fitment_id,
            mode_type:that.mode_type,
            file_name:flie_item.name,
            file_path:flie_item.path,
          },
        },ret=>{
          if(ret.code){
            that.$message.success('操作成功')
            that.getList()
          }else {
            that.$message.error(ret.msg||'操作失败')
          }
        })
      })
    },
    changeRemark(id, remarks) {
      const that=this;
      ERP.postRequest({
        url:"admin/HouseFitmentFile/addRemarks",
        data:{
          id:id,
          remarks:remarks,
        },
      },ret=>{
        if(ret.code){
          that.$message.success('保存成功！')
        }else{
          that.$message.error('保存失败！')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.link-span{
  width: 180px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/components/FitmentFileSubgroup.vue